import { createConfigLoader } from "@/config";

export interface IAdditionalSettings {
  hasGoldenVisa: boolean;
  hasOSBB: boolean;
}

const defaultAdditionalSettings: IAdditionalSettings = {
  hasGoldenVisa: false,
};

export const additonalSettingsConfig: IAdditionalSettings = createConfigLoader(
  defaultAdditionalSettings,
  "additionalSettings",
);

export const hasGoldenVisa = (): boolean => {
  return additonalSettingsConfig.hasGoldenVisa;
};

export const hasOSBB = (): boolean => {
  return additonalSettingsConfig.hasOSBB;
};
